import { motion } from "framer-motion";
import { Building2, ShieldCheck, Users } from "lucide-react";
import { Reveal } from "./Reveal";

const NODES = [
  {
    icon: Building2,
    label: "Australian Business",
    sub: "Your team, your goals, your systems",
    highlight: false,
  },
  {
    icon: ShieldCheck,
    label: "Synergy Outsourcing",
    sub: "Australian-led managed delivery & oversight",
    highlight: true,
  },
  {
    icon: Users,
    label: "Global Professional Team",
    sub: "Dedicated professionals, managed delivery",
    highlight: false,
  },
];

const Connector = ({ delay }) => (
  <div className="relative hidden h-px w-full bg-white/10 md:block" aria-hidden="true">
    <motion.span
      className="absolute top-1/2 h-1.5 w-1.5 -translate-y-1/2 rounded-full bg-brand"
      animate={{ left: ["0%", "100%"], opacity: [0, 1, 1, 0] }}
      transition={{ duration: 2.2, repeat: Infinity, delay, ease: "easeInOut" }}
    />
    <span className="absolute -top-px left-0 h-[3px] w-full bg-gradient-to-r from-transparent via-brand/30 to-transparent" />
  </div>
);

export default function DeliveryDiagram() {
  return (
    <Reveal>
      <div
        data-testid="delivery-diagram"
        className="grid grid-cols-1 items-center gap-6 md:grid-cols-[1fr_80px_1fr_80px_1fr] lg:grid-cols-[1fr_120px_1fr_120px_1fr]"
      >
        {NODES.map((node, i) => (
          <div key={node.label} className="contents">
            <div
              data-testid={`delivery-node-${i}`}
              className={`relative rounded-2xl border p-6 text-center md:p-8 ${
                node.highlight
                  ? "border-brand/40 bg-brand-soft shadow-[0_0_60px_-15px_rgba(26,127,85,0.25)]"
                  : "border-white/10 bg-ink-2"
              }`}
            >
              <div className="relative mx-auto mb-4 flex h-12 w-12 items-center justify-center">
                {node.highlight && (
                  <span className="absolute inset-0 rounded-full bg-brand/30 animate-pulse-ring" aria-hidden="true" />
                )}
                <span
                  className={`relative flex h-12 w-12 items-center justify-center rounded-full ${
                    node.highlight ? "bg-brand text-ink" : "bg-white/5 text-brand"
                  }`}
                >
                  <node.icon className="h-5 w-5" aria-hidden="true" />
                </span>
              </div>
              <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-400">
                {String(i + 1).padStart(2, "0")}
              </p>
              <h3 className="mt-1 font-display text-lg font-bold text-white">{node.label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-mist">{node.sub}</p>
            </div>
            {i < NODES.length - 1 && <Connector delay={i * 1.1} />}
          </div>
        ))}
      </div>
      <p className="mt-8 text-center font-mono text-xs tracking-wide text-slate-500" data-testid="delivery-transparency">
        Synergy Outsourcing is an Australian company, Australian-led, operating across Australia, the US and Canada.
      </p>
    </Reveal>
  );
}
